<template>
    <div>
        <commonheader :activeNavIdx="7"></commonheader>
        <el-main>
            <!-- 当前位置导航 -->
            <positionnav curPageName='联系我们'></positionnav>
            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="grid-content bg-purple" id='map'>
                        <!-- 地图 -->
                        <commonmap></commonmap>
                    </div>
                </el-col>
                <!-- <el-col :span="6" :offset="2">
                    <div class="grid-content bg-purple">
                        <contactus :contactStyle2='true'></contactus>
                    </div>
                </el-col> -->
                <div class="grid-content contactUs">
                    <contactus :contactStyle2='true'></contactus>
                </div>
            </el-row>
        </el-main>
        <commonfooter></commonfooter>
    </div>
</template>
<script>
import commonheader from "./common/commonHeader.vue"; //头部组件
import commonfooter from "./common/commonFooter.vue"; //底部组件
import commonmap from "./common/commonmap.vue";
import contactus from './common/contactUs.vue' //右侧联系我们组件
import positionnav from './common/positionNav.vue'

export default {
    name: "contactUs",
    components: {
        commonheader,
        commonfooter,
        commonmap,
        contactus,
        positionnav
    },
    data () {
        return {

        };
    },
    mounted () { },
    methods: {
        handler ({ BMap, map }) {
            let me = this;
            console.log(BMap, map);
            // 鼠标缩放
            map.enableScrollWheelZoom(true);
            // 点击事件获取经纬度
            map.addEventListener("click", function (e) {
                    console.log(e.point.lng, e.point.lat);
            })
                 }
    }
 };        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="stylus">
@media (min-width: 1399px){}
    .el-main
        width 1200px
        margin auto

.el-main
    min-height 800px
#map
    margin-right 300px
    box-sizing border-box
.contactUs
    width 265px
    position absolute
    right 0
    top 0
</style>


// WEBPACK FOOTER //
// src/components/contactUs.vue